function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.08488 4.82725C8.4754 4.43672 8.47538 3.80355 8.08484 3.41304L7.96466 3.29287C7.57413 2.90236 6.94096 2.90238 6.55045 3.29292L4.12881 5.71471C3.7383 6.10524 3.10513 6.10526 2.7146 5.71475L1.82725 4.82746C1.43672 4.43695 0.803551 4.43697 0.413039 4.82751L0.292871 4.94768C-0.0976413 5.33822 -0.0976208 5.97138 0.292916 6.3619L2.71474 8.78357C3.10528 9.17408 3.73844 9.17406 4.12895 8.78353L4.95618 7.9562L8.08488 4.82725Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.08488 12.8273C8.4754 12.4367 8.47538 11.8036 8.08484 11.413L7.96466 11.2929C7.57413 10.9024 6.94096 10.9024 6.55045 11.2929L4.12881 13.7147C3.7383 14.1052 3.10513 14.1053 2.7146 13.7148L1.82725 12.8275C1.43672 12.4369 0.803551 12.437 0.413039 12.8275L0.292871 12.9477C-0.0976413 13.3382 -0.0976208 13.9714 0.292916 14.3619L2.71474 16.7836C3.10528 17.1741 3.73844 17.1741 4.12895 16.7835L4.95618 15.9562L8.08488 12.8273Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.08488 20.8273C8.4754 20.4367 8.47538 19.8036 8.08484 19.413L7.96466 19.2929C7.57413 18.9024 6.94096 18.9024 6.55045 19.2929L4.12881 21.7147C3.7383 22.1052 3.10513 22.1053 2.7146 21.7148L1.82725 20.8275C1.43672 20.4369 0.803551 20.437 0.413039 20.8275L0.292871 20.9477C-0.0976413 21.3382 -0.0976208 21.9714 0.292916 22.3619L2.71474 24.7836C3.10528 25.1741 3.73844 25.1741 4.12895 24.7835L4.95618 23.9562L8.08488 20.8273Z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11 5.5C11 4.67157 11.6716 4 12.5 4H26.5C27.3284 4 28 4.67157 28 5.5C28 6.32843 27.3284 7 26.5 7H12.5C11.6716 7 11 6.32843 11 5.5Z",
  fill: "currentColor"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M11 13.5C11 12.6716 11.6716 12 12.5 12H26.5C27.3284 12 28 12.6716 28 13.5C28 14.3284 27.3284 15 26.5 15H12.5C11.6716 15 11 14.3284 11 13.5Z",
  fill: "currentColor"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M11 21.5C11 20.6716 11.6716 20 12.5 20H26.5C27.3284 20 28 20.6716 28 21.5C28 22.3284 27.3284 23 26.5 23H12.5C11.6716 23 11 22.3284 11 21.5Z",
  fill: "currentColor"
});

var SvgWorks = function SvgWorks(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWorks, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Works.5fd07905.svg";
export { ForwardRef as ReactComponent };